import { React, useState } from "react";
import { useDispatch } from "react-redux";
import { setContext } from "../../../features/context";
import Modal from "../../modal/Modal";

import { CommunityEdit, CommunityLicense } from "../../widgets";
import axiosCall from "../../../lib/axios";

const Settings = ({ language, signout, props }) => {
  ///////////////// INITIALIZE /////////////////
  const {
    level,
    community,
    editCommunity,
    setEditCommunity,
    editLicense,
    setEditLicense,
    qty,
  } = props;

  const dispatch = useDispatch();

  const [pubModal, setPubModal] = useState(false);

  ////////////// PUBLISH COMMUNITY //////////////
  const publishNow = async () => {
    let result = await axiosCall("community/publish", { cid: community._id });
    if (result.success) {
      //set community draft false
      let context = { ...community, draft: false };

      // reset context and close modal
      dispatch(setContext(context));
      setPubModal(false);
    } else if (result.refresh) {
      //token has been refreshed, try again
      publishNow();
    } else {
      //refresh token expired or unknown error
      signout();
    }
  };

  ///////////////// RENDER GUI /////////////////
  return (
    <>
      {editCommunity ? (
        <CommunityEdit
          language={language}
          community={community}
          signout={signout}
          setEditCommunity={setEditCommunity}
        />
      ) : editLicense ? (
        <CommunityLicense
          language={language}
          community={community}
          level={level}
          signout={signout}
          setEditLicense={setEditLicense}
        />
      ) : (
        <div className="page-section">
          {/* license */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "1em",
            }}
          >
            <div style={{ display: "flex" }}>
              <div className="heading-icon">t</div>
              <div className="subheading" style={{ overflow: "initial" }}>
                {language.labels.app.license}
              </div>

              {level > 4 && (
                <div
                  aria-hidden="true"
                  className="glyphs font-contrast hover"
                  style={{ padding: "0.5em" }}
                  onClick={() => {
                    setEditLicense(true);
                  }}
                >
                  w
                </div>
              )}
            </div>
          </div>
          {community.license_type && community.license_qty && (
            <div
              className="break-half"
              style={{ marginTop: "0.5em" }}
              dangerouslySetInnerHTML={{
                __html: language.labels.communities.license.types[
                  community.license_type
                ].replace(/{n}/g, qty),
              }}
            />
          )}

          {/* draft */}
          {community.draft && (
            <div
              style={{
                padding: "1em 0.3em 1.5em 0.3em",
              }}
            >
              <div
                className="alert"
                style={{
                  display: "flex",
                  gap: "0.75em",
                  fontWeight: "600",
                }}
              >
                <span className="glyphs">!</span>
                <span>{language.labels.communities.draft}</span>
              </div>
              <div style={{ marginTop: "0.5em" }}>
                {language.labels.communities.unlisted}
              </div>

              {level > 3 && (
                <button
                  className="button"
                  style={{ marginTop: "1em" }}
                  onClick={() => setPubModal(true)}
                >
                  {language.labels.app.publish_now}
                </button>
              )}
            </div>
          )}

          {/* settings */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: "2em",
            }}
          >
            <div style={{ display: "flex" }}>
              <div className="heading-icon">|</div>
              <div className="subheading" style={{ overflow: "initial" }}>
                {language.labels.app.settings}
              </div>

              {level > 2 && (
                <div
                  aria-hidden="true"
                  className="glyphs font-contrast hover"
                  style={{ padding: "0.5em" }}
                  onClick={() => {
                    setEditCommunity(true);
                  }}
                >
                  w
                </div>
              )}
            </div>
          </div>

          {/* exclusive knowledge */}
          <div
            style={{
              display: "flex",
              gap: "0.75em",
              margin: "0.5em 0.3em",
            }}
          >
            {community.ex_knowledge ? (
              <>
                <span className="glyphs">l</span>
                <span>{language.labels.communities.settings.ex_knowledge}</span>
              </>
            ) : (
              <>
                <span className="glyphs">k</span>
                <span>
                  {community.verified
                    ? language.labels.communities.settings.qualified_knowledge
                    : language.labels.communities.settings.open_knowledge}
                </span>
              </>
            )}
          </div>

          {/* default pathway notifications */}
          <div
            style={{
              display: "flex",
              gap: "0.75em",
              margin: "0.5em 0.3em",
            }}
          >
            {community.notify_pathways ? (
              <>
                <span className="glyphs">(</span>
                <span>
                  {language.labels.communities.settings.notify_pathways_on}
                </span>
              </>
            ) : (
              <>
                <span className="glyphs">)</span>
                <span>
                  {language.labels.communities.settings.notify_pathways_off}
                </span>
              </>
            )}
          </div>

          {/* Complimentary Subscriptions */}
          {community.free_pass > 0 && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "2.5em",
                }}
              >
                <div style={{ display: "flex" }}>
                  <div className="heading-icon">*</div>
                  <div className="subheading" style={{ overflow: "initial" }}>
                    {language.labels.communities.offers.special}
                  </div>
                </div>
              </div>
              <div
                className="quote-text"
                style={{
                  margin: "0.5em 0.3em",
                }}
              >
                {language.labels.communities.offers.free_pass.replace(
                  /{n}/g,
                  community.free_pass
                )}
              </div>
            </>
          )}
        </div>
      )}

      {/* Publish Modal */}
      <Modal
        className="modal-dynamic"
        title={language.labels.communities.publish.replace(
          /{org}/g,
          community.title
        )}
        show={pubModal}
        onClose={() => setPubModal(false)}
        onOk={publishNow}
        language={language}
      >
        <div
          style={{ fontSize: "1.1em" }}
          dangerouslySetInnerHTML={{
            __html: language.labels.communities.pub_warning,
          }}
        />
      </Modal>
    </>
  );
};

export default Settings;
